import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import {
  Horizontal,
  SBHorizontal,
  Vertical,
} from '@sorare/core/src/atoms/layout/flex';
import { LabelM, Title4 } from '@sorare/core/src/atoms/typography';

const Wrapper = styled(SBHorizontal).attrs({ gap: 2 })`
  align-items: flex-start;
  width: 100%;
`;
const Content = styled.div`
  padding-right: var(--double-unit);
`;

export const Header = () => {
  return (
    <Vertical gap={2}>
      <Wrapper gap={2}>
        <Content>
          <Horizontal gap={2}>
            <Title4>
              <FormattedMessage
                defaultMessage="Step up your game"
                id="primaryBuyModalGrid.helperTitle"
              />
            </Title4>
          </Horizontal>
        </Content>
      </Wrapper>
      <LabelM color="var(--c-nd-600)">
        <FormattedMessage
          id="primaryBuyModalGrid.helperDesc"
          defaultMessage="Collect Pro Cards of your favorite players to compete for amazing rewards."
        />
      </LabelM>
    </Vertical>
  );
};
